import React from 'react'
import Style from './Divider.module.css'
const Divider = ({title}) => {
    return (
        <div className={Style.DividerLiner}>
            <p className={Style.titleHolder}>{title}</p>
        </div>
    )
}

export default Divider
